import TVG from "./index.tvg";
import Tool from "./index.tool";

export default { TVG, Tool };
